"use client";
import {Card, CardContent} from "@/components/ui/card";
import {FaClock, FaUser} from "react-icons/fa";
import {FaLocationDot} from "react-icons/fa6";
import Link from "next/link";
import {Button} from "@/components/ui/button";
import ActivityTypeTag from "@/components/ActivitiesNew/ActivityTypeTag";
import {reworkDate} from "@/lib/helpers/reworkDate";
import ActivityMemberTypeTag from "@/components/ActivitiesNew/ActivityMemberTypeTag";
import {useState} from "react";
import ParticipantModal from "@/components/Participant/ParticipantModal";

//TODO Gestion de l'image + Bouton découvrir / modifier  => lien différent
export default function ActivityCard({id,title, slug,price,place_max,short_details,address,type,status,participant_count,date_event,img,own,mapsUrl,user,participants, isSlide = false, isLoc = false, date_end}){
    const [participantOpen, setParticipantOpen] = useState(false);
    return(
        <>
            <Card className={`border border-primary ${isSlide ? 'keen-slider__slide' : ''}`}>
                <CardContent className={"p-0 m-0"}>
                    <div className={"rounded-t-xl relative"}>
                        <Link href={isLoc ? `/locations/${slug}` :  `/activities/${slug}`}>
                            <img src={img ? img.path : "/imagedefault.png"} className={"object-cover rounded-t-xl min-w-full h-60"}/>
                        </Link>
                        <div className={"absolute top-2 w-full h-full"}>
                            <div className={"flex flex-col justify-between h-full "}>
                                <div className={"flex justify-end mx-4"}>
                                    <ActivityMemberTypeTag type={user.type} is_admin={user.is_admin} />
                                </div>
                                <div className={"flex  justify-between m-4"}>
                                    <ActivityTypeTag typeId={type}/>
                                    <div
                                        className={"bg-primary py-1 px-3 rounded font-semibold text-white text-sm"}>{price ? `${price}€` : "Gratuit"}</div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className={"grid gap-y-2 px-3"}>
                        <h4 className={"font-bold"}>{title} {status === 1 && (
                            <span className={"text-primary"}>(Brouillon)</span>)}</h4>
                        <p className={"line-clamp-2"}>{short_details}</p>
                        <p className={"flex gap-x-1 items-center text-[#E6A900]"}>
                            <FaClock/>
                            {reworkDate(date_event, false, "fr", true)}
                            {date_end ? " au " + reworkDate(date_end, false, "fr", true) : "" }
                        </p>
                        {mapsUrl
                            ?
                            <Link href={mapsUrl} target={"_blank"}>
                                <button className={"flex gap-x-1 items-center text-[#E6A900] underline"}>
                                    <FaLocationDot/>
                                    {address}
                                </button>
                            </Link>
                            :
                            <p className={"flex gap-x-1 items-center text-[#E6A900]"}>
                                <FaLocationDot/>
                                {address}
                            </p>
                        }

                        <button className={"flex gap-x-1 items-center text-[#E6A900]"} onClick={() => setParticipantOpen(true)}>
                            <FaUser/>
                            {participant_count}/{place_max}
                        </button>
                        <p className={"text-sm italic"}>
                            Activité proposé par : &nbsp;
                            <Link href={`/profile/${user.id}`}>
                            <span
                                className={"text-primary hover:underline"}
                            >
                                {user.firstname} {user.lastname}
                            </span>
                            </Link>
                        </p>
                        <div className={"flex justify-end p-3 gap-x-2"}>
                            {status === 1
                                ?
                                <Button className={"text-white"} asChild>
                                    <Link href={isLoc ? `locations/edit/${slug}` : `activities/edit/${slug}`}>
                                        Modifier
                                    </Link>
                                </Button>
                                :
                                <>
                                    {own && (
                                        <Button className={"text-white"} asChild>
                                            <Link href={isLoc ? `locations/edit/${slug}` : `activities/edit/${slug}`}>
                                                Modifier
                                            </Link>
                                        </Button>
                                    )}
                                    <Button className={"text-white"} asChild>
                                        <Link href={isLoc ? `/locations/${slug}` :`/activities/${slug}`}>
                                            Découvrir
                                        </Link>
                                    </Button>
                                </>

                            }

                        </div>
                    </div>
                </CardContent>
            </Card>
            <ParticipantModal
                participantOpen={participantOpen}
                participants={participants}
                setParticipantOpen={setParticipantOpen}
            />
        </>
    )
}